'use client'

import { useEffect, useState } from 'react'
import { getCookiePropertiesRules } from '../services'

export const usePropertiesRules = () => {
  const [propertiesRules, setPropertiesRules] = useState<any | null>(null)

  useEffect(() => {
    const cookiePropertiesRules = getCookiePropertiesRules()

    setPropertiesRules(cookiePropertiesRules)
  }, [])

  return { propertiesRules }
}

export default usePropertiesRules
